import React from "react";

/**
 * ServiceConnectionIndicator -- ExchangeNotification 서비스 연결 상태 인디케이터
 *
 * Props:
 * - status (string): 'ok' | 'error' | 'loading' | 'unknown'
 */
function ServiceConnectionIndicator({ status = "unknown" }) {
    const config = {
        ok: { dotClass: "h-2.5 w-2.5 rounded-full bg-gain", label: "서비스 정상" },
        degraded: { dotClass: "h-2.5 w-2.5 rounded-full bg-warning", label: "폴링 모드" },
        error: { dotClass: "h-2.5 w-2.5 rounded-full bg-loss", label: "서비스 장애" },
        loading: { dotClass: "h-2.5 w-2.5 rounded-full bg-content-muted animate-pulse", label: "확인 중..." },
        unknown: { dotClass: "h-2.5 w-2.5 rounded-full bg-content-muted", label: "상태 불명" },
    };

    const { dotClass, label } = config[status] || config.unknown;

    return (
        <span role="status" aria-label={label} className="inline-flex items-center gap-1.5 text-xs text-content-secondary">
            <span aria-hidden="true" className={dotClass} />
            {label}
        </span>
    );
}

export default ServiceConnectionIndicator;
